export const IMAGE_PLACEHOLDER = '/images/placeholders/placeholder_image.png';
